import { render, staticRenderFns } from "./InterBtnBox.vue?vue&type=template&id=fc599244&scoped=true&"
import script from "./InterBtnBox.vue?vue&type=script&lang=js&"
export * from "./InterBtnBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc599244",
  null
  
)

export default component.exports